import { render } from "./CalendarNavigator.vue?vue&type=template&id=0d439aa8&ts=true"
import script from "./CalendarNavigator.vue?vue&type=script&lang=ts"
export * from "./CalendarNavigator.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__